import { Injectable } from '@angular/core';
import { equalTo, orderByChild } from '@angular/fire/database';
import { HelperService } from 'src/app/services/helper.service';
import { DatabaseService } from './database.service';

@Injectable({
  providedIn: 'root'
})
export class ExercisesService {
  constructor(
    private dbService: DatabaseService,
    private helperService: HelperService,
  ) { }

    public async getExercises() {
      return this.dbService.getSnapshot(`/exercises`);
    }

    public async getExercisesAsArray() {
      const snapshot = await this.dbService.getSnapshot(`/exercises`);
      return this.helperService.transformFirebaseObjectToArray(snapshot);
    }

    public async getSystemExercises(arr: boolean = false) {
      const snap = await this.dbService.getSnapshot(`exercises`, orderByChild("organization"), equalTo("system"));
      return arr? this.helperService.transformFirebaseObjectToArray(snap) : snap;
    }

    public async getOrganizationExercises(organization, arr: boolean = false) {
      const snap = await this.dbService.getSnapshot(`exercises`, orderByChild("organization"), equalTo(organization));
      return arr? this.helperService.transformFirebaseObjectToArray(snap) : snap;
    }

}
